module.exports = __webpack_public_path__ + "img/fb13.89de5a15.jpg";